import { createFileRoute } from '@tanstack/react-router';
import { BlogPost } from '@/features/blogs/blog-post';

export const Route = createFileRoute('/_authenticated/blogs/$slug/')({
    head: () => ({ meta: [{ title: 'Blog | promote.fun' }] }),
    component: BlogPost,
});
